import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Calendar, MapPin, User, Mail, Clock, CheckCircle, School, Languages } from 'lucide-react';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { uri } from "constants/common";
import { cdn } from "constants/common";
import { appUrl } from 'services/config/secrets';

// import axios from 'axios';

const InterpretingForm = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    const [formData, setFormData] = useState({
        // 1
        email: '',
        todaysDate: today,
        personName: '',
        schoolId: '',
        // 2
        meetingType: '',
        endsByFour: '',
        // 3
        typeofmetting: '',
        otherMeetingType: '',
        // 4
        meetingDate: '',
        meetingStartTime: '',
        meetingEndTime: '',
        reportTo: '',
        additionalInterpreterInfo: '',
        additionalContact: '',
        studentSpecific: '',
        // 5
        studentName: '',
        guardianName: '',
        guardianPhone: '',
        // 6
        languageService: '',
        otherLanguage: '',
        dialect: '',
        // 7
        additionalInfo: '',
    });
    const [schools, setSchools] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [errors, setErrors] = useState({});

    const effectiveStep = currentStep === 8 ? 2 : currentStep;

    // Function to handle input changes
    const handleInputChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value,
        });

        if (errors[name]) {
            let isValid = true;

            // Email specific validation
            if (name === "email") {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                isValid = emailRegex.test(value);
            } else {
                // Baaki fields ke liye bas empty check
                isValid = value.trim() !== "";
            }

            if (isValid) {
                setErrors({
                    ...errors,
                    [name]: undefined, // error hatao sirf jab valid ho
                });
            }
        }
    };

    // Fetch schools data on component mount
    useEffect(() => {
        const fetchSchools = async () => {
            try {
                const response = await fetch(uri + '/get-schools');
                const data = await response.json();
                if (data.success) {
                    setSchools(data.data); // Update the schools list
                }
            } catch (error) {
                console.error('Error fetching schools:', error);
            }
        };

        fetchSchools();
    }, []);

    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                const response = await fetch(uri + '/get-languages');
                const data = await response.json();
                if (data.success) {
                    setLanguages(data.data); // Store the fetched language data
                }
            } catch (error) {
                console.error('Error fetching languages:', error);
            }
        };

        fetchLanguages();
    }, []);




    const steps = [
        { id: 1, title: '', icon: User },
        { id: 2, title: '', icon: Calendar },
        { id: 3, title: '', icon: Clock },
        { id: 4, title: '', icon: MapPin },
        { id: 5, title: '', icon: School },
        { id: 6, title: '', icon: Languages },
        { id: 7, title: '', icon: CheckCircle }
    ];

    const typeofmetting = [
        'SST / 504',
        'Initial IEP / Annual IEP',
        'TriAnnual IEP',
        'Student Assessment',
        'Pre-Expulsion / SARB',
        'Expulsion Hearing',
        'Board Meeting',
        'Parent Meeting',
        'Conference call / Phone Appt.',
        'Other:',
    ];

    const meetingTypes = [
        'In Person',
        'Phone',
        'Online Video Call (Zoom, Google Meet, or GotoMeeting)',
        // 'Continued Meeting (Part 2, 3, or 4).'
    ];

    const validateStep = (step) => {
        const newErrors = {};

        switch (step) {
            case 1:
                if (!formData.email) newErrors.email = 'Email is required';
                else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Must be a valid email';
                if (!formData.todaysDate) newErrors.todaysDate = 'Today\'s date is required';
                if (!formData.personName) newErrors.personName = 'Your name is required';
                if (!formData.schoolId) newErrors.schoolId = 'School ID is required';
                break;

            case 2:
                if (!formData.meetingType) newErrors.meetingType = 'Meeting type is required';
                // if (!formData.endsByFour) newErrors.endsByFour = 'You must specify if the meeting ends by 4:00 pm or sooner';
                break;

            case 3:
                if (!formData.typeofmetting) newErrors.typeofmetting = 'Type of meeting is required';
                if (formData.typeofmetting === 'Other:' && !formData.otherMeetingType) newErrors.otherMeetingType = 'Please specify the type of meeting';
                break;

            case 4:
                if (!formData.meetingDate) newErrors.meetingDate = 'Meeting date is required';
                if (!formData.meetingStartTime) newErrors.meetingStartTime = 'Meeting start time is required';
                if (!formData.meetingEndTime) newErrors.meetingEndTime = 'Meeting end time is required';
                if (!formData.reportTo) newErrors.reportTo = 'Report is required';
                // if (!formData.additionalContact) newErrors.additionalContact = 'Additional contact information is required';
                // if (!formData.studentSpecific) newErrors.studentSpecific = 'Please specify if the meeting is specific to a student';
                break;

            case 5:
                if (!formData.studentName) newErrors.studentName = 'Student\'s name is required';
                if (!formData.guardianName) newErrors.guardianName = 'Parent/Guardian\'s name is required';
                if (!formData.guardianPhone) newErrors.guardianPhone = 'Guardian phone number is required';
                // else if (!/\d{3}-\d{3}-\d{4}/.test(formData.guardianPhone)) newErrors.guardianPhone = 'Guardian phone number must be in the format xxx-xxx-xxxx';
                break;

            case 6:
                if (!formData.languageService) newErrors.languageService = 'Language service is required';
                if (formData.languageService === 'Other:' && !formData.otherLanguage) newErrors.otherLanguage = 'Please specify the language';
                break;

            default:
                break;
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleNext = () => {
        if (validateStep(currentStep)) {
            setCurrentStep((prev) => {
                if (prev === 2 && formData.endsByFour === "No") {
                    return 8;
                }

                if (prev === 4 && formData.studentSpecific === "No") {
                    return 6;
                }

                return Math.min(prev + 1, 7);
            });
        }
    };


    const handlePrevious = () => {
        setCurrentStep((prev) => {
            if (prev === 8) {
                return 2; // ✅ Step 8 se direct Step 1 pe bhejo
            }
            if (prev === 6 && formData.studentSpecific === "No") {
                return 4;
            }
            return Math.max(prev - 1, 1);
        });
    };

    const handleSubmit = async () => {
        if (validateStep(7)) {
            setLoading(true);
            try {
                const apiPayload = {
                    type: 0,
                    email: formData.email,
                    todays_date: formData.todaysDate,
                    contact_person_name: formData.personName,
                    school: formData.schoolId,

                    meeting_format: formData.meetingType,
                    meeting_end_before_4pm: formData.endsByFour === 'Yes',  // convert to true/false

                    meeting_type: formData.typeofmetting,

                    meeting_type_other: formData.otherMeetingType,
                    meeting_date: formData.meetingDate,
                    start_time: formData.meetingStartTime,
                    end_time: formData.meetingEndTime,
                    reporting_person: formData.reportTo,
                    additional_contact_number: formData.additionalContact,
                    specific_to_student: formData.studentSpecific === 'Yes',  // convert to true/false
                    other_related_information: formData.additionalInterpreterInfo,

                    student_name: formData.studentName,
                    parent_name: formData.guardianName,
                    parent_contact_number: formData.guardianPhone,

                    language_id: formData.languageService, // ensure this is ID, not name
                    language_other: formData.otherLanguage,
                    dialect: formData.dialect,
                    important_information: formData.additionalInfo,
                };

                const response = await fetch(uri+'/interpreting-service-request/generate', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(apiPayload),
                });

                const result = await response.json();

                // if (response.ok) {
                //     console.log('asdsdasasdasdsa', response);
                //     // alert('Appointment created successfully. Your Appointment ID is #A0004');
                //     Swal.fire({
                //         title: 'Success!',
                //         text: 'Appointment created successfully. Your Appointment ID is #' + result.message,
                //         icon: 'success',
                //         confirmButtonText: 'OK'
                //     });
                //     console.log('API Response:', result);
                //     // Optionally reset formData or redirect
            // }
                    if (response.ok) {
                        setLoading(false);
                        Swal.fire({
                            title: 'Success!',
                            text: 'Appointment created successfully. Your Appointment ID is #' + result.message,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            // setFormData({
                            //     email: '',
                            //     // todaysDate: '',
                            //     personName: '',
                            //     schoolId: '',
                            //     meetingType: '',
                            //     endsByFour: '',
                            //     typeofmetting: '',
                            //     otherMeetingType: '',
                            //     meetingDate: '',
                            //     meetingStartTime: '',
                            //     meetingEndTime: '',
                            //     reportTo: '',
                            //     additionalInterpreterInfo: '',
                            //     additionalContact: '',
                            //     studentSpecific: '',
                            //     studentName: '',
                            //     guardianName: '',
                            //     guardianPhone: '',
                            //     languageService: '',
                            //     otherLanguage: '',
                            //     dialect: '',
                            //     additionalInfo: '',
                            // });

                            // setCurrentStep(1);
                            window.location.reload();
                        });
                    }else {
                    setLoading(false);
                    const errorMessages = result?.errors
                        ? Object.values(result.errors).flat().join('\n')
                        : null;
                    Swal.fire({
                        title: 'Oops!',
                        text: errorMessages || result?.message || 'Submission failed. Please try again.',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                    // alert('Submission failed. Please try again.');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error submitting form:', error);
                Swal.fire({
                    title: 'Network Error',
                    text: 'There was a network error. Please try again later.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                // alert('There was a network error. Please try again later.');
            }
        }
    };

    


    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Stockton USD Interpreter Request Form</h2>
                            <p className="step-description">Please complete the form to request an interpreter from the Language Development Office.
                                <br />
                                <br />
                                Please complete one request for each student. Meetings that will take place or will go beyond the 4:00 pm workday, please complete the After Hour form: <a href={appUrl + '/interpreting-service-evening-request/generate'}>{appUrl + '/interpreting-service-evening-request/generate'}</a>
                                <br />
                                <br />
                                *Reasonable efforts are made to provide accurate interpretations during meetings. Our translators are proficient, certified, and competent in two languages although terminology and vocabulary may be newly introduced, causing a discrepancy in the translation. Descriptions are then described rather than the specific terminology.
                                Example: <strong> Gastritis.</strong> The word may or may not be recognized in the second language, although if a description is provided, the participants may understand what the word means - "an inflammation of the stomach."
                                <br />
                                <br />
                                To schedule an interpreter, please submit the form at least ten days <strong> (10 working days) prior </strong> to the date of the meeting by email or phone.  Please submit your request as quickly as possible as we schedule on a first come, first served basis.
                                <br />
                                <br />
                                PROCEDURES TO CANCEL AND RESCHEDULE INTERPRETER SERVICES
                                To cancel and reschedule, please contact the assigned interpreter directly by e-mail and provide the information that was submitted on the service request form.  Last minute cancellations: it is imperative to contact the assigned translator by email if the meeting has been canceled. <strong> Please contact the translators 24 hours in advance if the meeting has been canceled.</strong>
                                <br />
                                <br />
                                <strong> Bilingual  Proficiency  Exams can be scheduled on the Bilingual Proficiency Request Form.</strong> <a href={appUrl + '/entrance-exams/generate'}>{appUrl + '/entrance-exams/generate'}</a>
                                <br />
                                <br />
                                Language Development Office
                                <br />
                                56 S.  Lincoln Street Stockton, Ca 95203
                                <br />
                                Phone: (209) 933‐7075
                                <br />
                                FAX:     (209)	478‐2890
                                <br />
                                <br />
                                <span className='required'>* Indicates required question</span>
                            </p>
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Email <span className="required">*</span>
                            </label>
                            <input
                                type="email"
                                value={formData.email}
                                onChange={(e) => handleInputChange('email', e.target.value)}
                                className={`form-input ${errors.email ? 'error' : ''}`}
                                placeholder="Enter your email address"
                            />
                            {errors.email && <p className="error-message">{errors.email}</p>}
                        </div>

                        <div className="form-group d-none">
                            <label className="form-label">
                                Today's Date <span className="required">*</span>
                            </label>

                            <div className="input-image disabled">
                                <input                                    
                                    type="date"
                                    value={formData.todaysDate}
                                    onChange={(e) => handleInputChange('todaysDate', e.target.value)}
                                    className={`${errors.todaysDate ? 'error' : ''}`}
                                />
                                <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
                            </div>

                            {errors.todaysDate && (
                                <p className="error-message">{errors.todaysDate}</p>
                            )}
                        </div>



                        <div className="form-group">
                            <label className="form-label">
                                Person Completing the Form <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.personName}
                                onChange={(e) => handleInputChange('personName', e.target.value)}
                                className={`form-input ${errors.personName ? 'error' : ''}`}
                                placeholder="Complete Name for Person Completing the form (Your name)"
                            />
                            {errors.personName && <p className="error-message">{errors.personName}</p>}
                        </div>

                        {/* Dropdown for Schools */}
                        <div className="form-group">
                            <label className="form-label">Where will the meeting take place? <span className="required">*</span></label>
                            <select
                                value={formData.schoolId}
                                onChange={(e) => handleInputChange('schoolId', e.target.value)}
                                className={`form-input ${errors.schoolId ? 'error' : ''}`}
                            >
                                <option value="">Select a School</option>
                                {schools.map((school) => (
                                    <option key={school.id} value={school.id}>
                                        {school.name}
                                    </option>
                                ))}
                                {/* <option value="Other">Other</option> */}
                            </select>
                            {errors.schoolId && <p className="error-message">{errors.schoolId}</p>}
                        </div>

                    </div>
                );

            case 2:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Meeting Request Info</h2>
                            <p className="step-description">When and what type of meeting do you need interpretation for?</p>
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Format for Meeting<span className="required">*</span>
                            </label>
                            <select
                                value={formData.meetingType}
                                onChange={(e) => handleInputChange('meetingType', e.target.value)}
                                className={`form-input form-select ${errors.meetingType ? 'error' : ''}`}
                            >
                                <option value="">Select meeting type</option>
                                {meetingTypes.map(type => (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                            </select>
                            {errors.meetingType && <p className="error-message">{errors.meetingType}</p>}
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Will this meeting/event end by 4:00 pm or sooner?
                            </label>
                            <select
                                value={formData.endsByFour}
                                onChange={(e) => handleInputChange('endsByFour', e.target.value)}
                                className="form-input form-select"
                            >
                                <option value="">-- Select --</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>


                    </div>
                );

            case 3:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Type of Meeting</h2>
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Type of Meeting <span className="required">*</span>
                            </label>
                            <select
                                value={formData.typeofmetting}
                                onChange={(e) => handleInputChange('typeofmetting', e.target.value)}
                                className={`form-input form-select ${errors.typeofmetting ? 'error' : ''}`}
                            >
                                <option value="">-- Select --</option>
                                {typeofmetting.map((type) => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                            {errors.typeofmetting && (
                                <p className="error-message">{errors.typeofmetting}</p>
                            )}

                            {formData.typeofmetting === 'Other:' && (
                                <div className="form-group" style={{ marginTop: '0.5rem' }}>
                                    <label className="form-label">Please specify <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        name="otherMeetingType"
                                        value={formData.otherMeetingType || ''}
                                        onChange={(e) => handleInputChange('otherMeetingType', e.target.value)}
                                        className={`form-input ${errors.otherMeetingType ? 'error' : ''}`}
                                        placeholder="Enter custom meeting type"
                                    />
                                    {/* ✅ Error message render karein */}
                                    {errors.otherMeetingType && (
                                        <p className="error-message">{errors.otherMeetingType}</p>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                );

            case 4:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Please complete the following required information:
                            </h2>
                            {/* <p className="step-description">What language interpretation do you need?</p> */}
                        </div>


                        <div className="form-group">
                            <label className="form-label">
                                Meeting Date <span className="required">*</span>
                            </label>
                            <div className="input-image">
                                <input
                                    type="date"
                                    value={formData.meetingDate}
                                    onChange={(e) => handleInputChange('meetingDate', e.target.value)}
                                    className={`${errors.meetingDate ? 'error' : ''}`}
                                />
                                <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
                            </div>
                            {errors.meetingDate && <p className="error-message">{errors.meetingDate}</p>}
                        </div>

                        {/* Meeting Start Time */}
                        <div className="form-group">
                            <label className="form-label">
                                Meeting Start Time <span className="required">*</span><br />
                                <small>(A 2nd Translator/interpreter is needed for meetings longer than 2 hours).</small>
                            </label>
                            <div className="input-image">
                                <input
                                    type="time"
                                    value={formData.meetingStartTime}
                                    onChange={(e) => handleInputChange('meetingStartTime', e.target.value)}
                                    className={`${errors.meetingStartTime ? 'error' : ''}`}
                                />
                                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                            </div>
                            {errors.meetingStartTime && <p className="error-message">{errors.meetingStartTime}</p>}
                        </div>

                        {/* Meeting End Time */}
                        <div className="form-group">
                            <label className="form-label">
                                Meeting End Time<span className="required">*</span><br />
                                <small>(Please give additional time for interpretation, especially on Zoom)</small>
                            </label>
                            <div className="input-image">
                                <input
                                    type="time"
                                    value={formData.meetingEndTime}
                                    onChange={(e) => handleInputChange('meetingEndTime', e.target.value)}
                                    className={`${errors.meetingEndTime ? 'error' : ''}`}
                                />
                                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                            </div>
                            {errors.meetingEndTime && <p className="error-message">{errors.meetingEndTime}</p>}

                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Interpreter should report to whom?<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.reportTo || ''}
                                onChange={(e) => handleInputChange('reportTo', e.target.value)}
                                className={`form-input ${errors.reportTo ? 'error' : ''}`}
                                placeholder="Enter name or role (e.g., Ms. Johnson, Office Admin)"
                            />
                            {errors.reportTo && <p className="error-message">{errors.reportTo}</p>}
                        </div>

                        {/* Additional Contact Number */}
                        <div className="form-group">
                            <label className="form-label">
                                Additional Contact Number to be given to Interpreter (optional)
                            </label>
                            <input
                                type="tel"
                                value={formData.additionalContact}
                                onChange={(e) => handleInputChange('additionalContact', e.target.value)}
                                className="form-input"
                                placeholder="(209) 555-1234"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Other related information to share with the interpreter and LDO
                                <br />
                                <small>
                                    Overall information about the request (entry is limited to 250 characters).<br />
                                    Please email specifics to the interpreter directly once they are assigned.
                                </small>
                            </label>
                            <textarea
                                value={formData.additionalInterpreterInfo || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= 250) {
                                        handleInputChange('additionalInterpreterInfo', value);
                                    }
                                }}
                                className="form-input"
                                placeholder="Enter general information for interpreter and LDO"
                                rows={4}
                            />
                            <div className="char-count">{formData.additionalInterpreterInfo?.length || 0}/250</div>
                        </div>

                        {/* Is the meeting specific to a student? */}
                        <div className="form-group">
                            <label className="form-label">
                                Is the meeting specific to a student? (i.e. 504, IEP, SST, etc.)
                            </label>
                            <select
                                value={formData.studentSpecific}
                                onChange={(e) => handleInputChange('studentSpecific', e.target.value)}
                                className="form-input form-select"
                            >
                                <option value="">-- Select --</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>

                    </div>
                );

            case 5:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Please complete the following required information:
                            </h2>
                            {/* <p className="step-description">What language interpretation do you need?</p> */}
                        </div>


                        {/* Student's Name */}
                        <div className="form-group">
                            <label className="form-label">
                                Student's Name <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.studentName}
                                onChange={(e) => handleInputChange('studentName', e.target.value)}
                                className={`form-input ${errors.studentName ? 'error' : ''}`}
                                placeholder="Student's Full Name"
                            />
                            {errors.studentName && <p className="error-message">{errors.studentName}</p>}
                        </div>

                        {/* Parent or Guardian's Name */}
                        <div className="form-group">
                            <label className="form-label">
                                Parent or Guardian's Name <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                value={formData.guardianName}
                                onChange={(e) => handleInputChange('guardianName', e.target.value)}
                                className={`form-input ${errors.guardianName ? 'error' : ''}`}
                                placeholder="Parent or Guardian's Full Name"
                            />
                            {errors.guardianName && <p className="error-message">{errors.guardianName}</p>}
                        </div>

                        {/* Parent or Guardian's Phone Number */}
                        <div className="form-group">
                            <label className="form-label">
                                Parent or Guardian's Phone Number <span className="required">*</span><br />
                                <small>(NOTE: Translators don't make phone calls prior to meetings to confirm appointments for sites, unless arranged with the IEP team.)</small><br />
                                <small>Please include area code (xxx-xxx-xxxx)</small>
                            </label>
                            <input
                                type="tel"
                                value={formData.guardianPhone}
                                onChange={(e) => handleInputChange('guardianPhone', e.target.value)}
                                className={`form-input ${errors.guardianPhone ? 'error' : ''}`}
                                placeholder="(209) 555-6789"
                            />
                            {errors.guardianPhone && <p className="error-message">{errors.guardianPhone}</p>}
                        </div>

                    </div>
                            
                );

            case 6:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Which Language are you seeking services for? English is assumed as one of the languages.</h2>
                            {/* <p className="step-description">What language interpretation do you need?</p> */}
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Which language are you seeking services for? English is assumed as one of the languages. <span className="required">*</span>
                            </label>

                            <select
                                value={formData.languageService}
                                onChange={(e) => handleInputChange('languageService', e.target.value)}
                                className={`form-input form-select ${errors.languageService ? 'error' : ''}`}
                            >
                                <option value="">-- Select --</option>
                                {languages.map((lang) => (
                                    <option key={lang.id} value={lang.id}>
                                        {lang.name}
                                    </option>
                                ))}
                                <option value="Other:">Other:</option>
                            </select>

                            {errors.languageService && (
                                <p className="error-message">{errors.languageService}</p>
                            )}

                            {formData.languageService === 'Other:' && (
                                <div className="form-group" style={{ marginTop: '0.5rem' }}>
                                    <label className="form-label">Please specify <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        name="otherLanguage"
                                        value={formData.otherLanguage || ''}
                                        onChange={(e) => handleInputChange('otherLanguage', e.target.value)}
                                        className={`form-input ${errors.otherLanguage ? 'error' : ''}`}
                                        placeholder="Enter other language"
                                    />
                                    {errors.otherLanguage && (
                                        <p className="error-message">{errors.otherLanguage}</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label className="form-label">
                                Dialect (if applicable)
                            </label>
                            <input
                                type="text"
                                value={formData.dialect || ''}
                                onChange={(e) => handleInputChange('dialect', e.target.value)}
                                className="form-input"
                                placeholder="Specify dialect (if any)"
                            />
                        </div>

                    </div>
                );

            case 7:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Final Details of the Request</h2>
                            {/* <p className="step-description">What language interpretation do you need?</p> */}
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                Please add important information below.<br />
                                <small>
                                    EXAMPLE: Existing Reference Number - if you have one, your contact info below (phone and email), any additional comments regarding your request.
                                </small>
                            </label>
                            <textarea
                                value={formData.additionalInfo || ''}
                                onChange={(e) => handleInputChange('additionalInfo', e.target.value)}
                                className="form-input"
                                placeholder="Add reference number, contact info, or any other notes here..."
                                rows={4}
                            />
                        </div>

                    </div>
                );

            case 8:
                return (
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">
                                After Hour meetings/events that will start after 4:00 pm (OR events/meetings that don't end by 4:00 pm) should utilize the linked form below:
                            </h2>
                        </div>
                        <div className="form-group" style={{ textAlign: "center", marginTop: "1rem" }}>
                            <Link
                                to="/interpreting-service-evening-request/generate"
                                className="form-link"
                            >
                                Click here to fill out the After Hour Meeting Request Form
                            </Link>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="app-container">
            <style jsx>{`
           
        // input[type="date"].form-input {
        // padding-right: 2.5rem;  /* calendar icon ke liye jagah */
        // -webkit-appearance: auto;
        // appearance: auto;
        // }

        .app-container {
          min-height: 100vh;
              background: linear-gradient(#6F8DFF, #57CCF3);
          padding: 1rem;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        // .header {
        //   text-align: center;
        //   margin-bottom: 2rem;
        // }

        // .logo {
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        //   margin-bottom: 1rem;
        // }

        // .logo-badge {
        //   background: linear-gradient(to right, #2563eb, #9333ea, #059669);
        //   color: white;
        //   padding: 0.5rem 1.5rem;
        //   border-radius: 0.5rem;
        //   font-weight: bold;
        //   font-size: 1.25rem;
        // }
        .header {
        display: flex;
        flex-direction: column;
        align-items: center; /* Ye sab elements ko center mein laayega horizontally */
        text-align: center; /* Heading aur paragraph ka text bhi center ho jayega */
        gap: 10px; /* Optional, elements ke beech thodi spacing dene ke liye */
        }

        .logo-badge {
        /* Agar aapko logo ka size ya styling chahiye to yahan add karein */
        font-weight: bold;
        font-size: 24px;
        background: linear-gradient(to right, #2563eb, #9333ea, #059669);
                color: white;
                border-radius: 0.5rem;
                padding: 0.5rem 1.5rem;
        }
        .logo_wrapper{
           margin-bottom: 7px;
        }
        .logo_wrapper img{
           height: 80px;
        }

        .main-title {
          font-size: 2.4rem;
          font-weight: bold;
          color: #ffffffff;
          margin-bottom: 2.8rem;
        }

        .subtitle {
          color: #6b7280;
        }

        .progress-container {
          margin-bottom: 2rem;
        }

        .progress-steps {
          display: flex;
          justify-content: center;
        }

        .steps-wrapper {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .step {
          display: flex;
          align-items: center;
        }

        .step-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50%;
          border: 2px solid;
          transition: all 0.3s ease;
        }

        .step-icon.active {
          background-color: #2563eb;
          border: none;
          color: white;
          box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -4px 0 0 #00000054;
        }

        .step-icon.completed {
          background-color: #10b981;
          border: none;
          color: white;
           box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -4px 0 0 #00000054;
        }

        .step-icon.inactive {
          background-color: white;
          border-color: #d1d5db;
          color: #9ca3af;
        }
        .loader_wrapper{
            height: 100vh;
            width: 100vw;
            background-color: #ffffffb2;
            position: fixed;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            }
            .loader_wrapper img{
                height: 70px;
                animation: loader .8s infinite linear;
        }
        @keyframes loader{
            from{
                transform: rotate(0deg);
            }
            to{
                transform: rotate(360deg);
            }
        }         
        .disabled{
            cursor: no-drop; 
        }
        .disabled input{      
            pointer-events: none;
        }
        .step-label {
          margin-left: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .step-label.active,
        .step-label.completed {
          color: #1f2937;
        }

        .step-label.inactive {
          color: #9ca3af;
        }

        .step-connector {
          width: 2rem;
          height: 2px;
          margin: 0 1rem;
          transition: background-color 0.3s ease;
        }

        .step-connector.completed {
          background-color: #10b981;
          box-shadow: 1px 1px 2px 0px #00000059;
        }

        .step-connector.inactive {
          background-color: #d1d5db;
          box-shadow: 1px 1px 2px 0px #00000059;
        }

        .form-container {
          max-width: 48rem;
          margin: 0 auto;
        }

        .form-card {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          padding: 2rem;
        }

        .step-content {
          margin-bottom: 2rem;
        }

        .step-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .step-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 0.8rem;
        line-height: 1.3;
            text-align: start;
        }

        .step-description {
          color: #000000;
          line-height: 1.4;
          text-align: start;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        @media (max-width: 850px) {
          .logo_wrapper img {
           height: 80px;
        }
           .logo-img {
           padding: 9px;
           }
        .logo_wrapper {
            margin-bottom: 0px;
        }
          .form-row {
            grid-template-columns: 1fr;
          }
          
          .steps-wrapper {
            gap: 0.1rem;
          }
          
          .step-label {
            display: none;
          }
          
          .step-connector {
            width: 1rem;
            margin: 0 0.5rem;
          }
        }

        @media (max-width: 650px) {
            select.form-input {
                background-size: 1.5rem !important;
            }
            .step-icon {
                width: 2.1rem;
                height: 2.1rem;
            }
            .step-icon svg{
                height: 15px;
            }
            .main-title {
                font-size: 1.8rem;
            }
            .step-title {
               font-size: 1.6rem;
            }
            .steps-wrapper {
               gap: 0;
            }
        }
        .form-label {
          display: block;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin-bottom: 0.5rem;
          line-height: 1.5;
        }

        .required {
          color: #ef4444;
        }

        .form-input { 
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #d1d5db;
          border-radius: 0.5rem;
          font-size: 1rem;
          transition: all 0.2s ease;
          box-sizing: border-box;
        }
        select.form-input {
           appearance: none;      
           -webkit-appearance: none;   
           -moz-appearance: none; 
           background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0.75rem center;
        background-size: 1.8rem;
        }
        .form-input:focus {
          outline: none;
          border-color: transparent;
          box-shadow: 0 0 0 2px #6F8DFf;
        }

        .form-input.error {
          border-color: #ef4444;
        }

        .form-select {
          appearance: none;      
         -webkit-appearance: none;   
         -moz-appearance: none; 
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
          background-position: right 0.5rem center;
          background-repeat: no-repeat;
          background-size: 1.5em 1.5em;
          padding-right: 2.5rem;
          appearance: none;
        }
                @media (max-width: 550px) {
                .nav-button.success{
                    width: min-content;
                }
           }
        .form-textarea {
          resize: vertical;
          min-height: 2.5rem;
        }

        .error-message {
          color: #ef4444;
          font-size: 0.875rem;
          margin-top: 0.25rem;
        }

        .notice {
          padding: 1rem;
          border-radius: 0.5rem;
          font-size: 0.875rem;
          margin-top: 1rem;
        }

        .notice-warning {
          background-color: #fefce8;
          border: 1px solid #fde047;
          color: #92400e;
        }

        .notice-info {
          background-color: #eff6ff;
          border: 1px solid #93c5fd;
          color: #1e40af;
        }

        .notice-success {
          background-color: #f0fdf4;
          border: 1px solid #86efac;
          color: #166534;
        }

        .review-summary {
          background-color: #f9fafb;
          border-radius: 0.5rem;
          padding: 1.5rem;
          margin-bottom: 1rem;
        }

        .summary-title {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1f2937;
          border-bottom: 1px solid #e5e7eb;
          padding-bottom: 0.5rem;
          margin-bottom: 1rem;
        }

        .summary-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }

        @media (max-width: 768px) {
          .summary-grid {
            grid-template-columns: 1fr;
          }
        }

        .summary-item {
          margin-bottom: 1rem;
        }

        .summary-item.full-width {
          grid-column: 1 / -1;
        }

        .summary-label {
          font-size: 0.875rem;
          color: #6b7280;
          margin-bottom: 0.25rem;
        }

        .summary-value {
          font-weight: 500;
          color: #1f2937;
        }

        .navigation{
            margin-top: 2rem;
            border-top: 1px solid #e5e7eb;
            padding-top: 1.5rem;
                
        }
        .navigation_inner {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .navigation .step-indicator.one{
           display: none;  
           text-align: center;
           margin-bottom: 13px;       
        }
        .nav-button {
          display: flex;
          align-items: center;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          font-weight: 500;
          border: none;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 1rem;
        }

        .nav-button:disabled {
          background-color: #f3f4f6;
          color: #9ca3af;
          cursor: not-allowed;
        }

        .nav-button.primary {
          background-color: #6F8DFf;
          color: white;
            box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 2px 0 0 hsla(0, 0%, 100%, .25), inset 0 -3px 0 0 #4e6bdd;
        }

        .nav-button.primary:hover:not(:disabled) {
          background-color: #6785ffff;
        }
        .nav-button.primary:active:not(:disabled) {
            box-shadow: none;
        }
        .nav-button.secondary {
          background-color: #e5e7eb;
          color: #374151;
        }

        .nav-button.secondary:hover:not(:disabled) {
          background-color: #d1d5db;
        }

        .nav-button.success {
          background-color: #059669;
          color: white;
        }

        .nav-button.success:hover:not(:disabled) {
          background-color: #047857;
        }

        .step-indicator {
          font-size: 0.875rem;
          color: #6b7280;
        }

        .footer {
          text-align: center;
          margin-top: 2rem;
          font-size: 0.875rem;
          color: #6b7280;
        }

        .footer p {
          margin: 0.25rem 0;
        }
        @media (max-width: 470px) {
            .step-icon.active{
                box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -3px 0 0 #00000054;
            }
            .step-icon.completed {
                box-shadow: 0 2px 8px 0 #6F8DFF4d, inset 0 1px 0 0 hsla(0, 0%, 100%, .25), inset 0 -3px 0 0 #00000054;

            }
            .logo_wrapper img {
                height: 65px;
            }
            .main-title {
                font-size: 1.8rem;
                margin-bottom: 1.9rem;
            }    
            .step-icon svg {
                height: 12px;
            }
            .step-icon {
                width: 1.7rem;
                height: 1.7rem;
            }
            .step-connector {
                margin: 0 0.3rem;
            }
            .nav-button {
                font-size: 0.9rem;
                padding: 0.65rem 1.1rem;
            }
            .nav-button.primary svg{
                margin-left: 0.1rem !important;
            }
            .nav-button.previous svg{
                margin-right: 0.1rem !important;
            }
            .form-card {
                padding: 1.2rem;
            }
                
            .form-input {
                font-size: 0.95rem;
            }
                .step-description{
    font-size: 14px; 
}
                    .step-title {
        font-size: 1.4rem;
    }
        }
        @media (max-width: 400px) {
            .container{
                padding: 0 !important;
            }
        }
        @media (max-width: 550px) {
            .navigation .step-indicator.one{
                display: block;
            }
            .navigation_inner .step-indicator.two{
                display: none;
            }
            .navigation {
                padding-top: 1rem;
                }
            
                }

                `}</style>

            <div className="container">
                {/* Header */}
                <div className="header">
                    <div className="logo">
                        <div className="logo_wrapper">
                            <img src="/images/logo-fill.png" alt="ALGOVI Logo" className="logo-img" />
                        </div>
                    </div>
                    <h1 className="main-title">Interpreter Request Form</h1>
                    {/* <p className="subtitle">Stockton USD Language Development Office</p> */}
                </div>

                {/* Progress Steps */}
                {/* <div className="progress-container">
                    <div className="progress-steps">
                        <div className="steps-wrapper">
                            {steps.map((step, index) => {
                                const Icon = step.icon;

                                // ✅ Agar step 8 pe hain to progress ko Step 2 tak hi count karo

                                const isActive = effectiveStep === step.id;
                                const isCompleted = effectiveStep > step.id;

                                return (
                                    <div key={step.id} className="step">
                                        <div
                                            className={`step-icon ${isActive ? "active" : isCompleted ? "completed" : "inactive"
                                                }`}
                                        >
                                            <Icon size={20} />
                                        </div>
                                        <div
                                            className={`step-label ${isActive || isCompleted
                                                ? isActive
                                                    ? "active"
                                                    : "completed"
                                                : "inactive"
                                                }`}
                                        >
                                            {step.title}
                                        </div>
                                        {index < steps.length - 1 && (
                                            <div
                                                className={`step-connector ${isCompleted ? "completed" : "inactive"
                                                    }`}
                                            />
                                        )}
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                </div> */}

                {/* Form Content */}
                <div className="form-container">
                    <div className="form-card">
                        {renderStepContent()}

                        {/* Navigation Buttons */}
                        <div className="navigation">
                            <span className="step-indicator one">
                                Step {effectiveStep} of {steps.length}
                            </span>
                            <div className="navigation_inner">
                                <button
                                    onClick={handlePrevious}
                                    disabled={currentStep === 1}
                                    className={`nav-button previous ${currentStep === 1 ? '' : 'secondary'}`}
                                >
                                    <ChevronLeft size={20} style={{ marginRight: '0.5rem' }} />
                                    Previous
                                </button>

                                <span className="step-indicator two">
                                    Step {effectiveStep} of {steps.length}
                                </span>

                                {currentStep < 7 ? (
                                    <button
                                        onClick={handleNext}
                                        className="nav-button primary"
                                    >
                                        Next
                                        <ChevronRight size={20} style={{ marginLeft: '0.5rem' }} />
                                    </button>
                                ) : currentStep === 8 ? (
                                     <div style={{width: '110px'}}>

                                    </div>
                                ) : (
                                    <button
                                        onClick={handleSubmit}
                                        className="nav-button success"
                                    >
                                        Submit Request
                                        <CheckCircle size={20} style={{ marginLeft: '0.5rem' }} />
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="copy_right" style={{ textAlign: 'center', margin: '2rem', fontSize: '15px', lineHeight: '1.5' }}>
                    <p>Copyrights 2025 <a href="https://algovisolutions.com/">Algovi Services LLC.</a> All rights reserved</p>
                </div>
            </div>
            {loading && (
      <div className="loader_wrapper">
        <img src="/images/form_loader.svg" alt="" />
      </div>
    )}
            
        </div>
        
    );
};

export default InterpretingForm;